import React, { Component } from 'react';
import Modal from 'react-modal';
import LeadPackUpsellOffer from './LeadPackUpsellOffer';
import LeadPackUpsellSuccess from './LeadPackUpsellSuccess';
import PropTypes from 'prop-types';
import { ActionTypes } from './constants/LeadPackUpsell';

const modalStyle = {
  overlay: {
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  content: {
    border: 'none',
    borderRadius: '8px',
    outline: 'none',
    padding: '0',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '360px'
  }
};

export class LeadPackUpsellModal extends Component {
  static propTypes = {
    gaCategory: PropTypes.string,
    loading: PropTypes.bool,
    purchase: PropTypes.object,
    actions: PropTypes.object,
    leadPackUpsell: PropTypes.object,
    contactName: PropTypes.string,
    checksum: PropTypes.string,
    jobInvitationId: PropTypes.number,
    data: PropTypes.object,
    isOpen: PropTypes.bool,
    actionTypes: PropTypes.array,
    logo: PropTypes.string,
    coin: PropTypes.string,
    siteSource: PropTypes.string,
    needRedirect: PropTypes.bool
  };

  constructor() {
    super();

    this.state = {
      modalIsOpen: true
    };

    Modal.setAppElement('body');
  }

  componentDidMount() {
    window.onload = () => {
      this.props.actions.viewOffer();
    };
  }

  componentWillReceiveProps(nextProps) {
    const purchase = this.props.purchase;
    const nextPurchase = nextProps.purchase;

    if (
      purchase &&
      purchase.status !== ActionTypes.SUBMIT_PURCHASE_LEAD_PACK_UPSELL_ERROR &&
      nextPurchase &&
      nextPurchase.status === ActionTypes.SUBMIT_PURCHASE_LEAD_PACK_UPSELL_ERROR
    ) {
      // eslint-disable-next-line
      alert(nextPurchase.feedback.error);

      this.closeModal();
    }
  }

  declineOffer = () => {
    const { actions, jobInvitationId, checksum, purchase, loading } = this.props;

    if (!loading && purchase.status !== ActionTypes.SUBMIT_PURCHASE_LEAD_PACK_UPSELL_SUCCESS) {
      actions.declineOffer(jobInvitationId, checksum);
    }

    this.closeModal();
  };

  dismissOffer = () => {
    const { actions, loading } = this.props;

    if (!loading) {
      actions.dismissOffer();
    }

    this.closeModal();
  };

  closeModal = () => {
    const { loading, needRedirect } = this.props;

    if (loading) {
      return;
    }

    this.setState({ modalIsOpen: false });

    if (needRedirect) {
      setTimeout(function() {
        window.location.href = '/account/leads/invited';
      }, 5000);
    }
  };

  render() {
    const { modalIsOpen } = this.state;
    const {
      data,
      contactName,
      purchase,
      actions,
      jobInvitationId,
      loading,
      checksum,
      gaCategory,
      coin,
      logo,
      siteSource
    } = this.props;

    return (
      <Modal
        style={modalStyle}
        isOpen={modalIsOpen}
        onRequestClose={this.dismissOffer}
        jobInvitationId={jobInvitationId}
        contentLabel="Modal"
      >
        <div
          ref={ref => {
            this.modalRef = ref;
          }}
        >
          {purchase.status !== ActionTypes.SUBMIT_PURCHASE_LEAD_PACK_UPSELL_SUCCESS && (
            <LeadPackUpsellOffer
              data={data}
              contactName={contactName}
              checksum={checksum}
              jobInvitationId={jobInvitationId}
              declineOffer={this.declineOffer}
              selectOffer={actions.selectOffer}
              submitPurchaseOffer={actions.submitPurchaseOffer}
              loading={loading}
              gaCategory={gaCategory}
              coin={coin}
              siteSource={siteSource}
            />
          )}
          {purchase.status === ActionTypes.SUBMIT_PURCHASE_LEAD_PACK_UPSELL_SUCCESS && (
            <LeadPackUpsellSuccess
              leadPackValue={purchase.feedback.success.offer_value}
              remainingValue={purchase.feedback.success.remaining_credit}
              onClickButton={this.closeModal}
              logo={logo}
              siteSource={siteSource}
            />
          )}
        </div>
      </Modal>
    );
  }
}
